import "./JoinGame.scss";
import { QRCodeCanvas } from "../QRCodeCanvas";
import useSoundEffect from "../../../hooks/useSoundEffect";
import { useState } from "react";
import { getRandomName } from "../../../utils/nameGenerator";
import { useMultiplayer } from "../../../context/MultiplayerContext";
import { getSavedLobby, removeSavedLobby } from "../../../utils/multiplayer/savedLobbyManager";

export default function JoinGame() {
    const { multiplayerState, joinGame } = useMultiplayer();

    document.body.style.backgroundImage = "url('images/table2-4k.webp')";

    const { playSelectAudio } = useSoundEffect();
    const [isGenerating, setIsGenerating] = useState(false);
    const [username, setUsername] = useState("");

    if (!multiplayerState.showUserNamePage) return null;

    const savedSession = getSavedLobby();
    const isSameSession = multiplayerState.lobbyId === savedSession?.lobbyId;

    if (isSameSession) {
        joinGame(savedSession.lobbyId, savedSession.username, true);
        return null;
    } else {
        removeSavedLobby();
    }

    async function generateRandomName() {
        if (isGenerating) return;
        setIsGenerating(true);
        const generatedName = await getRandomName();
        setUsername(generatedName);
        setIsGenerating(false);
    }

    function handleSubmit(e: React.FormEvent) {
        e.preventDefault();
        playSelectAudio();

        const trimmedUsername = username.trim();
        if (!trimmedUsername) {
            console.error("Username cannot be empty");
            return;
        }

        joinGame(multiplayerState.lobbyId!, trimmedUsername);
    }

    if (!multiplayerState.lobbyId) {
        console.error("Missing lobbyId");
        return null;
    }

    return (
        <div className="join-game" data-testid="join-game">
            <form className="join-game-form" onSubmit={handleSubmit}>
                <h1>Enter a Name</h1>

                <label htmlFor="username">Name</label>
                <div className="input-row">
                    <input
                        type="text"
                        id="username"
                        placeholder={isGenerating ? "Generating..." : "Enter your name"}
                        autoComplete="off"
                        value={username}
                        onChange={(e) => setUsername(e.target.value)}
                        required
                    />
                    <button
                        type="button"
                        className="generate-btn"
                        onClick={async () => {
                            playSelectAudio();
                            await generateRandomName();
                        }}
                        disabled={isGenerating}
                        title="Generate random name"
                    >
                        Generate Name
                    </button>
                </div>

                <input type="submit" className="chess-button" value="Join Game" />

                <div className="qr-cont">
                    <QRCodeCanvas lobbyId={multiplayerState.lobbyId} id="qr-code" />
                </div>
            </form>
        </div>
    );
}
